import { useLocation, useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

const usePagination = (initialPageSize = 50) => {
  const navigate = useNavigate();
  const location = useLocation();
  const search = useSearch({ strict: false });

  const getPaginationQueryParams = () => {
    try {
      const searchParams = search as { pageIndex?: string; pageSize?: string };

      const pageIndex = Number.parseInt(searchParams.pageIndex ?? "", 10);
      const pageSize = Number.parseInt(searchParams.pageSize ?? "", 10);

      if (!isNaN(pageIndex) && !isNaN(pageSize)) {
        return { pageIndex, pageSize };
      } else {
        return {
          pageIndex: 0,
          pageSize: initialPageSize,
        };
      }
    } catch (e) {
      return {
        pageIndex: 0,
        pageSize: initialPageSize,
      };
    }
  };

  const updatePaginationQueryParams = (paginationState: any) => {
    const updateUrl = () => {
      navigate({
        to: location.pathname,
        search: {
          ...(search as Record<string, unknown>),
          pageIndex: paginationState.pageIndex ?? 0,
          pageSize: paginationState.pageSize ?? initialPageSize,
        } as any,
        replace: true,
      });
    };

    updateUrl();
  };

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: initialPageSize,
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = getPaginationQueryParams();
      setPagination(params);
    }
  }, [search]);

  const onPaginationChange = (paginationState: any) => {
    let newState = {
      pageIndex: 0,
      pageSize: initialPageSize,
    };
    setPagination((old) => {
      newState = paginationState(old);
      updatePaginationQueryParams(newState);
      return newState;
    });
    return newState;
  };

  return {
    pagination,
    onPaginationChange,
  };
};

export default usePagination;
